import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';

export type PushEhrCredentialsV2Payload = {
  org_uuid: string;
  ehr_system: string;
  credentials: Record<string, unknown>;
};

export type PushEhrCredentialsV2Response = {
  success: boolean;
  code: number;
  message?: string;
  data?: unknown;
};

export const usePushEhrCredentialsV2 = (
  options?: UseMutationOptions<
    PushEhrCredentialsV2Response,
    Error,
    PushEhrCredentialsV2Payload
  >
) => {
  const { mutateAsync, ...rest } = useMutation<
    PushEhrCredentialsV2Response,
    Error,
    PushEhrCredentialsV2Payload
  >({
    mutationFn: (payload) =>
      integrationsApi
        .post<PushEhrCredentialsV2Response>('/v2/ehr/credentials', payload)
        .then((res) => res.data),
    ...options,
  });

  return { pushCredentials: mutateAsync, ...rest };
};
